module.exports = __webpack_public_path__ + "img/10-1_04.6e77054d.jpg";